/**
 * Assign Pro 
 */
export const assignPro = {
    /** AssignPro -AssignProComponent  */
    headerText: 'ASSIGNING JOB',
    /**  ProListComponent*/
    tableHeading: {
        Profile: 'Profile',
        Name: 'Name',
        Email: 'Email',
        Password: 'Password',
        PhoneNumber: 'Phone Number',
        Address: 'Address',
        BtnText: 'Assign Me',
    },
    buyerProperty: 'Buyer Property Address',
    status: 'Accept status',
    date: 'Accepted Date',
    noProUser: 'No pro user ',
    assignAgn: 'Assign other pro',
    declineReason: 'Reason for decline',
    noData: 'No data available'

}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/utils/e-commerce/assignPro.ts